import React from "react";

const CloseButton = ({
  onClick,
  ariaLabel = "Close",
  className = "btn-close",
}) => {
  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      aria-label={ariaLabel}
    ></button>
  );
};

export default CloseButton;
